// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3DzV0","error":"Textarea_error__2HC5i","readonly":"Textarea_readonly__2RltZ","disabled":"Textarea_disabled__7GWHe"};